import { collection, doc, getDoc, updateDoc, setDoc, addDoc} from "@firebase/firestore";
import { db } from "../config/firebase";
import { getDate, getCalendar, getTime, getCurrentYear } from "./basicHelper";

/**
 * Checks if the city exists in the world or not
 * @param   :   City Name
 * @return  :   bool    -   true; if city exists
 *                      -   false; otherwise
 */
export const IsCityValid = () => {
    return true
}

/**
 * Is Called when the gym already exists
 * Checks whether the status is active or not
 * @param   :   city    -   contains the city Name
 * @return  :   bool    -   false; if gymDoc exists and is active, true; otherwise
 */
export const IfGymDocExists = async (city, gymDoc, gymDocRef, toUpdate) => {
    // Get the gymData
    const gymData = gymDoc.data()
    
    // Check if the status of the gym is active or not
    if (gymData.status === true) {
        console.log('The gym is already active and listed!');
        return false;
    }
    // Else make gymstatus active
    else {
        // Update the status of the Gym
        await updateDoc(gymDocRef, toUpdate);

        // Increment the number of active gyms in the city
        const cityRef = collection(db, 'Cities');
        const cityDocRef = doc(cityRef, city);
        const cityDoc = await getDoc(cityDocRef);
        const cityData = cityDoc.data();

        await updateDoc(cityDocRef, {
            'NoOfActiveGyms'    : cityData.NoOfActiveGyms + 1,
        });

        return true;
    }
}

/**
 * Adds further collections to the {gym}
 * @param   : gymDocRef
 * @return  : true; if sccuessful, false; otherwise
 */
export const addCollectionsToGyms = async (gymDocRef) => {
    try {
        const reviewsRef    = collection(gymDocRef, 'Reviews');
        const calendarRef   = collection(gymDocRef, 'Calendar');
        const usersRef      = collection(gymDocRef, 'Users');
        const financeRef    = collection(gymDocRef, 'Finances');
        const staffRef      = collection(gymDocRef, 'Staff');
        const classRef      = collection(gymDocRef, 'Classes')

        await setDoc(doc(reviewsRef, 'testReview'), { 
            Rating: 0,  
            Name: 'CollectionStarter',
        });

        const {year, month, date} = getCalendar();

        await setDoc(doc(calendarRef, getDate()), { 
            timestamp               : getTime(),
            totalUsersAttendance    : 0,
            year                    : year,
            month                   : month,
            date                    : date
        });

        await setDoc(doc(usersRef, 'testUser'), { 
            userName: 'Owner',
            userID: '000',
            memberSince: new Date(),
            gymMembershipID: '000'
        });

        await setDoc(doc(financeRef, getCurrentYear()), {
            totalRevenue : 0,
            totalExpense : 0 
        });

        // Make a Classes collection
        await setDoc(doc(classRef, 'testClass'), {
            availableSlots      : -1,
            priceForMembers     : -1,
            priceForNonMembers  : -1,

        });

        // Making a Staff collection
        await setDoc(doc(staffRef, 'owner'), {
            position    : 'Test',
            staffName   : 'Test',
            staffID     : '000',

        });

        // Make Further collection in Finances

        const revenueRef = collection(financeRef, getCurrentYear(), 'Revenue');
        const expenseRef = collection(financeRef, getCurrentYear(), 'Expense');

        await addDoc(revenueRef, {
            amount : 0
        });

        await addDoc(expenseRef, {
            amount : 0
        });

        return true;

    } catch (error) {
        console.log('Error : ', error);
        return false;
    }
}

/**
 * Adds further collections to the {studio}
 * @param   : studioDocRef
 * @return  : true; if sccuessful, false; otherwise
 */
export const addCollectionsToStudios = async (studioDocRef) => {
    try {
        const reviewsRef    = collection(studioDocRef, 'Reviews');
        const calendarRef   = collection(studioDocRef, 'Calendar');
        const usersRef      = collection(studioDocRef, 'Users');
        const financeRef    = collection(studioDocRef, 'Finances');
        const staffRef      = collection(studioDocRef, 'Staff');
        const classRef      = collection(studioDocRef, 'Classes')

        await setDoc(doc(reviewsRef, 'testReview'), { 
            Rating: 0,  
            Name: 'CollectionStarter',
        });

        const {year, month, date} = getCalendar();

        await setDoc(doc(calendarRef, getDate()), { 
            timestamp               : getTime(),
            totalUsersAttendance    : 0,
            year                    : year,
            month                   : month,
            date                    : date
        });

        await setDoc(doc(usersRef, 'testUser'), { 
            userName: 'Owner',
            userID: '000',
            memberSince: new Date(),
            studioMembershipID: '000'
        });

        await setDoc(doc(financeRef, getCurrentYear()), {
            totalRevenue : 0,
            totalExpense : 0 
        });

        // Make a Classes collection
        await setDoc(doc(classRef, 'testClass'), {
            availableSlots      : -1,
            priceForMembers     : -1,
            priceForNonMembers  : -1,

        });

        // Making a Staff collection
        await setDoc(doc(staffRef, 'owner'), {
            position    : 'Test',
            staffName   : 'Test',
            staffID     : '000',

        });

        // Make Further collection in Finances

        const revenueRef = collection(financeRef, getCurrentYear(), 'Revenue');
        const expenseRef = collection(financeRef, getCurrentYear(), 'Expense');

        await addDoc(revenueRef, {
            amount : 0
        });

        await addDoc(expenseRef, {
            amount : 0
        });

        return true;

    } catch (error) {
        console.log('Error : ', error);
        return false;
    }
}

/**
 * Is Called when the studio already exists
 * Checks whether the status is active or not
 * @param   :   city    -   contains the city Name
 * @return  :   bool    -   false; if studioDoc exists and is active, true; otherwise
 */
export const IfStudioDocExists = async (city, studioDoc, studioDocRef, toUpdate) => {
    // Get the studioData
    const studioData = studioDoc.data()
    
    // Check if the status of the studio is active or not
    if (studioData.status === true) {
        console.log('The studio is already active and listed!');
        return false;
    }
    // Else make studiostatus active
    else {
        // Update the status of the studio
        await updateDoc(studioDocRef, toUpdate);

        // Increment the number of active studios in the city
        const cityRef = collection(db, 'Cities');
        const cityDocRef = doc(cityRef, city);
        const cityDoc = await getDoc(cityDocRef);
        const cityData = cityDoc.data();

        await updateDoc(cityDocRef, {
            'NoOfActiveStudios'    : cityData.NoOfActiveStudios + 1,
        });

        return true;
    }
}

/**
 * formats the name of the Equpiment
 * @param {String} name 
 * @returns 
 */
export const formatEquipmentName = (name) => {
    return name.replace(/([a-z])([A-Z])/g, '$1 $2');
};